import * as React from 'react'
import type { SVGProps } from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import { CommonComponentProps } from '@pijma/hero-types'

export const IconCloseSmall = (
  props: SVGProps<SVGSVGElement> & CommonComponentProps,
) => (
  <PijmaComponent
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    as="svg"
    commonProps={props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5858 12L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L12 10.5858L16.2929 6.29289C16.6834 5.90237 17.3166 5.90237 17.7071 6.29289C18.0976 6.68342 18.0976 7.31658 17.7071 7.70711L13.4142 12L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L12 13.4142L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L10.5858 12Z"
      fill="currentColor"
    />
  </PijmaComponent>
)
